var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_9622)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8021_9622",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8021_9622)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8021_9622)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8021_9622",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H6V18H18V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8021_9622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.676 6.3244C17.5283 6.17539 17.341 6.07194 17.1363 6.02637C16.9315 5.98081 16.7179 5.99505 16.521 6.06741L16.413 6.10591C14.0008 6.88605 11.8046 8.21976 10 10.0004C9.09394 11.0158 8.3056 12.1304 7.65 13.3229L8.793 14.5004L7.5 15.7934L8.207 16.5004L9.5 15.2074L10.66 16.3674C11.8522 15.7116 12.9667 14.9233 13.982 14.0174C15.7686 12.2064 17.1085 10.004 17.8955 7.58491L17.933 7.4794C18.0053 7.2825 18.0196 7.06895 17.974 6.86418C17.9284 6.65942 17.8251 6.47205 17.676 6.3244ZM11.5 13.0004C11.4011 13.0004 11.3044 12.9711 11.2222 12.9161C11.14 12.8612 11.0759 12.7831 11.038 12.6917C11.0002 12.6004 10.9903 12.4999 11.0096 12.4029C11.0289 12.3058 11.0765 12.2168 11.1465 12.1468C11.2164 12.0769 11.3055 12.0293 11.4025 12.01C11.4994 11.9908 11.6 12.0006 11.6913 12.0385C11.7827 12.0763 11.8608 12.1404 11.9157 12.2226C11.9707 12.3048 12 12.4015 12 12.5004C12 12.633 11.9473 12.7602 11.8535 12.854C11.7597 12.9478 11.6326 13.0004 11.5 13.0004ZM13 11.5004C12.9011 11.5004 12.8044 11.4711 12.7222 11.4161C12.64 11.3612 12.5759 11.2831 12.538 11.1917C12.5002 11.1004 12.4903 10.9998 12.5096 10.9029C12.5289 10.8058 12.5765 10.7168 12.6465 10.6468C12.7164 10.5769 12.8055 10.5293 12.9025 10.51C12.9994 10.4908 13.1 10.5006 13.1913 10.5385C13.2827 10.5763 13.3608 10.6404 13.4157 10.7226C13.4707 10.8048 13.5 10.9015 13.5 11.0004C13.5 11.133 13.4473 11.2602 13.3535 11.354C13.2597 11.4478 13.1326 11.5004 13 11.5004ZM14.5 10.0004C14.4011 10.0004 14.3044 9.97108 14.2222 9.91614C14.14 9.8612 14.0759 9.78311 14.038 9.69175C14.0002 9.60039 13.9903 9.49985 14.0096 9.40286C14.0289 9.30587 14.0765 9.21678 14.1465 9.14685C14.2164 9.07693 14.3055 9.02931 14.4025 9.01001C14.4994 8.99072 14.6 9.00063 14.6913 9.03847C14.7827 9.07631 14.8608 9.1404 14.9157 9.22262C14.9707 9.30484 15 9.40151 15 9.50041C15 9.63302 14.9473 9.76019 14.8535 9.85396C14.7598 9.94773 14.6326 10.0004 14.5 10.0004ZM15.4735 13.8814C15.4107 14.689 15.1769 15.4739 14.7874 16.1841C14.3979 16.8943 13.8617 17.5134 13.2145 18.0004H11.5V17.0394C12.6471 16.3907 13.717 15.6143 14.6895 14.7249C14.965 14.4504 15.2235 14.1674 15.4735 13.8814ZM9.2755 9.28441C8.38612 10.2568 7.60968 11.3268 6.961 12.4739H6V10.7594C6.48699 10.1122 7.10614 9.576 7.81633 9.18651C8.52651 8.79702 9.31146 8.56314 10.119 8.50041C9.833 8.75041 9.55 9.00891 9.2755 9.28441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79552 14.4974L7.43945 15.8535L8.14656 16.5606L9.50263 15.2046L8.79552 14.4974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1027 5.89526L17.1383 7.63172L16.3662 6.85959L18.1027 5.89526Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8021_9622",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_9622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricActions);
export default __webpack_public_path__ + "static/media/Metric-Actions.857141a1277f79818bd3c1af0ed93cd3.svg";
export { ForwardRef as ReactComponent };